import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { median } from '../teacher-analytics/utils/data-parser';
import { CSVLink } from 'react-csv';

export default class ChapterAggregationTable extends PureComponent {
  reshapeData = chapterData => {
    let outData = [];
    let tempObj;
    chapterData.forEach(nodeObj => {
      nodeObj.activity_aggregate.forEach(activityAgg => {
        tempObj = {
          reference: activityAgg.activity_reference,
          id: activityAgg._id,
          accuracy:
            (median(Object.values(activityAgg.distribution_score)) /
              activityAgg.max_score) *
            100,
          time: median(Object.values(activityAgg.distribution_time)) / 60,
          num_data_points: Object.values(activityAgg.distribution_time).length,
          position_in_chapter: nodeObj.position_in_chapter,
          attempt_location: nodeObj.attempt_location,
          type: nodeObj.type,
        };
        outData.push(tempObj);
      });
    });
    //TODO: Add data for which sheet is the latest one.
    return outData;
  };
  render() {
    const { data } = this.props;
    if (!data) {
      return <div>No Data</div>;
    }
    let processedData = this.reshapeData(data);
    return (
      <div>
        <CSVLink data={data} filename={'Chapter_data_'}>
          Download to CSV
        </CSVLink>
        {processedData && (
          <ReactTable
            data={processedData}
            pageSize={processedData.length}
            pageSizeOptions={[25, 30, 50, 100, 200, 500]}
            columns={[
              {
                Header: 'Chapter',
                columns: [
                  {
                    Header: 'Index',
                    id: 'row',
                    maxWidth: 50,
                    filterable: false,
                    Cell: row => {
                      return <div>{row.index + 1}</div>;
                    },
                  },
                  {
                    Header: 'Position',
                    accessor: 'position_in_chapter',
                    maxWidth: 80,
                  },
                  {
                    Header: 'Activity Reference',
                    id: 'reference',
                    maxWidth: 300,
                    accessor: d => (
                      <a
                        href={'/activity-analytics/' + d.id}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {d.reference}
                      </a>
                    ),
                  },
                  {
                    Header: 'Accuracy(%) ',
                    id: 'accuracy',
                    maxWidth: 80,
                    accessor: d => d.accuracy.toFixed(2),
                  },

                  {
                    Header: 'Time (Median)',
                    id: 'time',
                    maxWidth: 80,
                    accessor: d => d.time.toFixed(2),
                  },

                  {
                    Header: 'Location',
                    accessor: 'attempt_location',
                    maxWidth: 80,
                  },
                  {
                    Header: 'Type',
                    accessor: 'type',
                    maxWidth: 80,
                  },
                  {
                    Header: '#Data Points',
                    id: 'num_data_points',
                    maxWidth: 80,
                    accessor: d => d.num_data_points,
                  },
                ],
              },
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    );
  }
}
